module.exports = __webpack_public_path__ + "img/acacia-sky-biking.31cee2b0.jpg";